import React, { useState } from "react";
import { ReactComponent as ShareIcon } from "./../../../assets/images/icons/Google SVGs/share.svg";
import { ReactComponent as CancelIcon } from "./../../../assets/images/icons/Google SVGs/cancel.svg";

import { ReactComponent as TwitterIcon } from "./../../../assets/images/icons/Social/twitter.svg";
import { ReactComponent as WhatsappIcon } from "./../../../assets/images/icons/Social/whatsapp.svg";
import { ReactComponent as TelegramIcon } from "./../../../assets/images/icons/Social/telegram.svg";
import { ReactComponent as EitaaIcon } from "./../../../assets/images/icons/Social/eitaa.svg";
import { ReactComponent as CopyIcon } from "./../../../assets/images/icons/Google SVGs/copy.svg";

import haveAccess from "../../../utilities/functions/haveAccess";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import apiConfig from "../../../utilities/apiConfig.json";
import serverConfig from "../../../utilities/serverConfig.json";
import { QRCode } from "react-qrcode-logo";
import copy from "copy-to-clipboard";
import PrintToPDF from "../../cards/printToPDF";
import axios from "axios";

const ShareLinkModal = (props) => {
  const { roles } = useSelector((state) => state.user);
  const [phonenumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const headers = {
    Authorization: "Bearer " + localStorage.getItem("token"),
  };

  const shareLinkAPI = () => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url + apiConfig.api.sendDataAPIs.shareLinkBySMS,
        {
          mobile: phonenumber,
          name: props.name,
          link: props.link,
        },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
        } else {
          if (response.data.code == 404) {
            toast.error(response.data.message);
          } else if (typeof response.data.errors === "string") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  return (
    <>
      <div
        className="modal fade"
        id="shareModal"
        aria-hidden="true"
        aria-labelledby="shareModalLabel"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header border-bottom mx-12px pt-3 pb-2 p-0">
              <span className="fs-16 fw-medium color-bootstrap-gray-900">
                اشتراک گذاری
              </span>
              <CancelIcon
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  //   setDepartment([]);
                  //   setPlace([]);
                  //   setShowPhone(false);
                }}
                width={24}
                height={24}
                className="ms-auto"
              />
            </div>

            <div className="modal-body pb-0 pt-2">
              <div className="d-flex flex-column">
                <span className="fs-14 color-bootstrap-gray-700">
                  با استفاده از روش های زیر میتوانید صفحه را با افراد مختلف به
                  اشتراک بگذارید
                </span>

                <div
                  className="card p-2 my-4 color-bootstrap-gray-700 border-0 fs-12 fw-normal align-self-center"
                  style={{
                    background:
                      "linear-gradient(136.72deg, #F8F9FA 3.14%, #E9ECEF 96.67%)",
                  }}
                >
                  <div className="card-body d-flex p-3 bg-iso-white rounded-2 justify-content-center">
                    {/* QR Code */}
                    <QRCode
                      value={window.location.href}
                      size={haveAccess(roles, "print_sharelink") ? 136 : 184}
                      qrStyle="fluid"
                      quietZone={0}
                      ecLevel="L"
                      eyeRadius={[
                        {
                          // top/left eye
                          outer: [8, 8, 0, 8],
                          inner: [0, 0, 0, 0],
                        },
                        {
                          // top/left eye
                          outer: [8, 8, 8, 0],
                          inner: [0, 0, 0, 0],
                        },
                        {
                          // top/left eye
                          outer: [8, 0, 8, 8],
                          inner: [0, 0, 0, 0],
                        },
                      ]}
                    />
                  </div>

                  {/* {haveAccess(roles, "print_sharelink") && ( */}
                  <PrintToPDF
                    text={props.text}
                    subtext={
                      props.subtext && props.subtext.length > 0
                        ? props.subtext
                        : ""
                    }
                    targetLink={window.location.href}
                  />
                  {/* )} */}
                </div>

                {haveAccess(roles, "send_sharelink_sms") && (
                  <div className="card w-100 mb-4 background-bootstrap-gray-100 color-bootstrap-gray-700 border-0 fs-12 fw-normal">
                    <div className="card-body d-flex p-2 flex-column">
                      <span className="fs-14 color-bootstrap-gray-600">
                        پیامک
                      </span>
                      <span className="fs-14 color-bootstrap-gray-700">
                        برای اشتراک گذاری این صفحه فقط کافی است شماره همراه
                        مراجعه کننده را وارد کنید و ارسال را بزنید.
                      </span>

                      <form className="d-flex flex-row mt-3">
                        <input
                          style={{ direction: "rtl" }}
                          className="d-flex col align-items-center form-control px-2 py-2 fs-14 align-items-center d-flex"
                          type="number"
                          id="SMSPhone"
                          disabled={loading}
                          placeholder="شماره همراه بیمار"
                          value={phonenumber}
                          onChange={(e) => {
                            setPhoneNumber(e.target.value);
                          }}
                        />

                        <button
                          type="button"
                          disabled={loading}
                          className="d-flex col-auto btn bg-iso-blue-300 color-bootstrap-gray-100 border-radius-8 fs-14 fw-normal px-12px py-2 ms-2 align-items-center"
                          onClick={() => {
                            if (phonenumber && phonenumber.length == 11) {
                              shareLinkAPI();
                            } else {
                              toast.warning("شماره همراه صحیح نمی‌باشد");
                            }
                          }}
                        >
                          ارسال
                          {loading && (
                            <>
                              <span
                                class="spinner-grow spinner-grow-sm ms-1"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span class="visually-hidden">Loading...</span>
                            </>
                          )}
                          {/* <span className="bg-iso-blue-200 py-0 color-iso-white px-2 rounded ms-2">
                            5 از 20
                          </span> */}
                        </button>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer border-bootstrap-gray-300 px-0">
              <div className="d-flex row w-100 m-0 color-bootstrap-gray-800">
                <div className="d-flex col flex-column align-items-center">
                  <a
                    type="button"
                    className="btn w-fit p-2"
                    style={{ backgroundColor: "#1DA1F226" }}
                    href={
                      "https://www.twitter.com/share?url=" +
                      window.location.href
                    }
                  >
                    <TwitterIcon width={24} height={24} />
                  </a>
                  <span className="mt-2 fs-12 fw-normal">توییتر</span>
                </div>

                <div className="d-flex col flex-column align-items-center">
                  <a
                    type="button"
                    className="btn w-fit p-2"
                    style={{ backgroundColor: "#25D36626" }}
                    href={"whatsapp://send?text=" + window.location.href}
                  >
                    <WhatsappIcon width={24} height={24} />
                  </a>
                  <span className="mt-2 fs-12 fw-normal">واتس اپ</span>
                </div>

                <div className="d-flex col flex-column align-items-center">
                  <a
                    type="button"
                    className="btn w-fit p-2"
                    style={{ backgroundColor: "#0088CC26" }}
                    href={
                      "tg://msg?text=" +
                      encodeURIComponent(window.location.href)
                    }
                  >
                    <TelegramIcon width={24} height={24} />
                  </a>
                  <span className="mt-2 fs-12 fw-normal">تلگرام</span>
                </div>

                <div className="d-flex col flex-column align-items-center">
                  <a
                    type="button"
                    className="btn w-fit p-2"
                    style={{ backgroundColor: "#EF7C0026" }}
                    href={
                      "https://eitaa.com/share/url?url=" +
                      window.location.href.toString()
                    }
                  >
                    <EitaaIcon width={24} height={24} />
                  </a>
                  <span className="mt-2 fs-12 fw-normal">ایتا</span>
                </div>

                <div className="d-flex col flex-column align-items-center">
                  <button
                    type="button"
                    className="btn w-fit p-2 background-bootstrap-gray-200"
                    onClick={() => {
                      //   navigator.clipboard.writeText(window.location.href);
                      copy(window.location.href.toString());
                      toast.success("کپی شد");
                    }}
                  >
                    <CopyIcon width={24} height={24} />
                  </button>
                  <span className="mt-2 fs-12 fw-normal">کپی لینک</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="d-flex fs-12 btn btn-light color-bootstrap-gray-700 rounded-3 h-fit p-2"
        data-bs-toggle="modal"
        data-bs-target="#shareModal"
        role="button"
      >
        <ShareIcon width={18} />
        {!props.justIcon && (
          <span className="d-lg-flex d-none ms-1">اشتراک گذاری</span>
        )}
      </div>
    </>
  );
};

export default ShareLinkModal;
